import { Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

export const PreviewDetailsSidebarSection: FC<{
  title: string;
  icon: ReactNode;
  children: ReactNode;
}> = ({ title, icon, children }) => {
  return (
    <Stack
      direction="column"
      spacing={1}
      justifyContent="center"
      sx={{ p: 2, borderWidth: 1, borderColor: "grey.200", borderStyle: "solid" }}
    >
      <Stack direction="row" spacing={1}>
        {icon}
        <Typography variant="overline" sx={{ textTransform: "uppercase" }}>
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
